import { SITE_URL, SITE_NAME } from '../components/SEO.jsx';

export const buildOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  sameAs: [],
});

export const buildWebsiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
});

export const buildProductSchema = (product, comments = []) => {
  if (!product) return null;

  const ratings = comments.filter((c) => typeof c.rating === 'number');
  const aggregateRating = ratings.length
    ? {
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: (ratings.reduce((sum, c) => sum + c.rating, 0) / ratings.length).toFixed(1),
          reviewCount: ratings.length,
        },
      }
    : {};

  const reviews = ratings.slice(0, 10).map((c) => ({
    '@type': 'Review',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: c.rating,
    },
    author: {
      '@type': 'Person',
      name: c.author || c.username || 'Client',
    },
    reviewBody: c.text || c.comment || '',
  }));

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.title,
    image: product.image || product.img,
    description: product.description || product.title,
    sku: product._id,
    offers: {
      '@type': 'Offer',
      url: `${SITE_URL}/product/${product._id}`,
      priceCurrency: 'USD',
      price: product.price,
      availability: 'https://schema.org/InStock',
    },
    ...aggregateRating,
    ...(reviews.length ? { review: reviews } : {}),
  };
};
